export const START_DATE = '[START_DATE]';
export const END_DATE = '[END_DATE]';
export const DATA_POINTS_NUMBER = '[DATA_POINTS_NUMBER]';
export const DURATION = '[DURATION]';
export const RADON_AVG_VALUE = '[RADON_AVG_VALUE]';
export const RADON_MIN_VALUE = '[RADON_MIN_VALUE]';
export const RADON_MAX_VALUE = '[RADON_MAX_VALUE]';
